import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import { ProductPurchaseServiceContext } from 'src/contexts/state-machines/purchase/ProductPurchaseServiceContext';
import { useIsMobile } from 'src/reservation-page/hooks/helpers/useIsMobile';
import { RSDetailHeader } from 'src/reservation-page/detail-header/RSDetailHeader';
import { RSDetailHeaderButton } from 'src/reservation-page/detail-header/RSDetailHeaderButton';

import { ProductSummary } from 'src/organisms/product-purchase/ProductSummary';

import styles from '../../index.module.css';

export interface ContentViewProps {
  onRequireClosing: () => void;
  onRequireNext: () => void;
}

export const ContentView: FC<ContentViewProps> = ({
  onRequireClosing,
  onRequireNext,
}) => {
  const intl = useIntl();

  const isMobile = useIsMobile();

  const dataProductDetail = ProductPurchaseServiceContext.useSelector(
    (state) => state.context.data.productDetail!,
  );

  return (
    <>
      <div className="z-5 sticky top-0">
        <RSDetailHeader
          title={intl.formatMessage({
            defaultMessage: '回数券購入',
            id: 'skpPN9',
            description:
              'src/templates/merchants/resources/book/components/product-purchase-modal/TicketBookPurchaseModal/components/ContentView/index.tsx',
          })}
          leftButton={
            <RSDetailHeaderButton variant="close" onClick={onRequireClosing}>
              {intl.formatMessage({
                defaultMessage: '閉じる',
                id: 'mSpDgx',
                description:
                  'src/templates/merchants/resources/book/components/product-purchase-modal/TicketBookPurchaseModal/components/ContentView/index.tsx',
              })}
            </RSDetailHeaderButton>
          }
          rightButton={
            <RSDetailHeaderButton
              variant="ok"
              onClick={onRequireNext}
              disabled={typeof dataProductDetail === 'undefined'}
            >
              {intl.formatMessage({
                defaultMessage: '次へ',
                id: 'n09ne5',
                description:
                  'src/templates/merchants/resources/book/components/product-purchase-modal/TicketBookPurchaseModal/components/ContentView/index.tsx',
              })}
            </RSDetailHeaderButton>
          }
        />
      </div>

      <div
        className={classnames(
          'overflow-y-auto',
          isMobile
            ? styles.mobileHeightRestriction
            : styles.pcHeightRestriction,
        )}
      >
        <div className="pc:px-4 pc:pt-4 border-b border-l-0 border-r-0 border-t-0 border-solid border-gray-50 px-2.5 pb-2.5 pt-3">
          <ProductSummary productDetail={dataProductDetail} />
        </div>

        <div className="pc:px-4 pc:pb-4 px-2.5 pb-6 pt-2.5">
          <div className="rs-font text-16 pc:text-15 whitespace-pre-wrap font-normal">
            {dataProductDetail.description}
          </div>
        </div>
      </div>
    </>
  );
};
